// Per-player scoring average across recorded matches — winner_avg/loser_avg on
// each match belong to whoever actually won/lost, not to player1/player2, so
// attribution has to follow the score comparison, not the field position.
export function computePlayerAverages(matches) {
  var byPlayer = {};
  matches.forEach(function(m) {
    var p1Won = m.score1 > m.score2;
    var winnerName = p1Won ? m.player1 : m.player2;
    var loserName = p1Won ? m.player2 : m.player1;
    if (winnerName && m.winner_avg !== null && m.winner_avg !== undefined) {
      if (!byPlayer[winnerName]) byPlayer[winnerName] = [];
      byPlayer[winnerName].push(parseFloat(m.winner_avg));
    }
    if (loserName && m.loser_avg !== null && m.loser_avg !== undefined) {
      if (!byPlayer[loserName]) byPlayer[loserName] = [];
      byPlayer[loserName].push(parseFloat(m.loser_avg));
    }
  });

  var result = {};
  Object.keys(byPlayer).forEach(function(name) {
    var avgs = byPlayer[name];
    if (avgs.length === 0) return;
    var sum = avgs.reduce(function(a, b) { return a + b; }, 0);
    result[name] = {
      average: Math.round((sum / avgs.length) * 100) / 100,
      best: Math.round(Math.max.apply(null, avgs) * 100) / 100,
      worst: Math.round(Math.min.apply(null, avgs) * 100) / 100,
      matches: avgs.length,
    };
  });
  return result;
}
